import React, { useState } from "react";
import { useToast } from "../hooks/use-toast";
import { feralStays } from "../mock";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EnquiryForm = ({ defaultVenue = "", title = "Enquire now" }) => {
  const { toast } = useToast();
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    venue: defaultVenue,
    arrival: "",
    nights: "",
    guests: "",
    message: "",
  });

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast({ title: "Please add your name and email so we can reply." });
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/stay-enquiry`, {
        name: form.name,
        email: form.email,
        phone: form.phone,
        venue: form.venue,
        arrival: form.arrival,
        guests: form.guests,
        message: form.message,
      });
      toast({
        title: "Enquiry sent",
        description: `Thanks ${form.name.split(" ")[0]} — we've got your enquiry and the team will be in touch soon.`,
      });
      setForm({
        name: "",
        email: "",
        phone: "",
        venue: defaultVenue,
        arrival: "",
        nights: "",
        guests: "",
        message: "",
      });
    } catch (err) {
      toast({ title: "Something went wrong", description: "Please try again in a moment." });
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls =
    "w-full bg-white border border-[#d9c3a8] px-4 py-3 rounded-sm outline-none focus:ring-2 focus:ring-[#ebc754] text-[#1e231f]";

  return (
    <form onSubmit={submit} className="bg-[#f3e7d6] border border-[#d9c3a8] rounded-md p-6 md:p-8">
      <h3 className="feral-serif text-[#9b3d0a] text-3xl mb-6">{title}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-[#1e231f] mb-1.5">Name *</label>
          <input className={inputCls} value={form.name} onChange={(e) => update("name", e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#1e231f] mb-1.5">Email *</label>
          <input type="email" className={inputCls} value={form.email} onChange={(e) => update("email", e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#1e231f] mb-1.5">Phone</label>
          <input className={inputCls} value={form.phone} onChange={(e) => update("phone", e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#1e231f] mb-1.5">Venue</label>
          <select className={inputCls} value={form.venue} onChange={(e) => update("venue", e.target.value)}>
            <option value="">Either / not sure</option>
            {feralStays.venues.map((v) => (
              <option key={v.slug} value={v.name}>{v.name}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-[#1e231f] mb-1.5">Arrival date</label>
          <input type="date" className={inputCls} value={form.arrival} onChange={(e) => update("arrival", e.target.value)} />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#1e231f] mb-1.5">Guests</label>
          <input type="number" min="1" className={inputCls} value={form.guests} onChange={(e) => update("guests", e.target.value)} />
        </div>
      </div>
      <div className="mt-4">
        <label className="block text-sm font-medium text-[#1e231f] mb-1.5">Tell us about your stay</label>
        <textarea rows={4} className={inputCls} value={form.message} onChange={(e) => update("message", e.target.value)} />
      </div>
      <button type="submit" disabled={submitting} data-testid="stay-enquiry-submit-button" className="w-full mt-6 bg-[#9b3d0a] hover:bg-[#7e3208] disabled:opacity-60 text-[#f2e5de] py-3.5 rounded-full tracking-[0.15em] text-sm font-semibold transition-colors duration-300">
        {submitting ? "SENDING…" : "SEND ENQUIRY"}
      </button>
    </form>
  );
};

export default EnquiryForm;
